import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import * as saveAs from 'file-saver';
import { CompanyResponsibleDto } from 'src/app/domain/models/dto/company-responsible.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';

@Component({
  selector: 'app-company-partners',
  templateUrl: './company-partners.component.html',
  styleUrls: ['./company-partners.component.scss'],
})
export class CompanyPartnersComponent implements OnInit {
  isMobile: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkWindowSize();
  }

  private readonly notifier: NotifierService;
  @Input() partnerData: CompanyResponsibleDto[];

  constructor(
    private readonly ordersService: OrdersService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.checkWindowSize();
  }

  checkWindowSize() {
    this.isMobile = window.innerWidth <= 820;
  }

  downloadAttachmentByName(fileName: string) {
    this.ordersService.downloadDocuments(fileName).subscribe({
      next: (data: any) => {
        saveAs(data, fileName);
        this.notifier.notify(
          'success',
          'Download do arquivo realizado com sucesso.'
        );
      },
      error: (err) => {
        this.notifier.notify('error', 'Erro ao efetuar o download do arquivo.');
      },
    });
  }

  togglePanel(event: Event) {
    const header = event.currentTarget as HTMLElement;
    const panelBody = header.nextElementSibling as HTMLElement;
    const expandIcon = header.querySelector('.expand-icon') as HTMLElement;

    if (panelBody.classList.contains('open')) {
      panelBody.classList.remove('open');
      expandIcon.style.transform = 'rotate(0deg)';
    } else {
      panelBody.classList.add('open');
      expandIcon.style.transform = 'rotate(180deg)';
    }
  }
}
